<template>
  <div v-if="warnings.length" class="warnings">
    <label class="title" v-if="title">
      {{ title }}
    </label>

    <ul class="warnings-list">
      <li v-for="(warning, index) of warnings" :key="`warning_${index}`" class="warning">{{ warning }}</li>
    </ul>
  </div>
</template>

<script>
// Wyświetla warningi
export default {
  props: {
    // Schema z warningami
    model: {type: Object, required: true},
    // Tytuł
    title: {type: String, required: false}
  },
  computed: {
    warnings() {
      return this.model
        .$checkAll()
        .map(warnedObject => warnedObject.$warnings)
        .filter(warnings => !!warnings && !!warnings.length)
        .reduce((a, b) => a.concat(b), []);
    }
  }
};
</script>

<style>
.warnings .warning {
  color: #b8860b;
}

.warnings .title {
  font-weight: bold;
}
</style>
